import React from 'react';
import styled from "styled-components";
import {useLocation} from "react-router-dom";
interface ScreenWrapperProps {
    children: React.ReactNode;
}
const ScreenWrapper: React.FC<ScreenWrapperProps> = ({children}) => {
    const {pathname} = useLocation();
    console.log(pathname)
    return (
        <Container pathname={pathname}>
            {children}
        </Container>
    );
};

export default ScreenWrapper;

const Container = styled.div<{pathname:string}>`
    width: 100%;
    height: ${({pathname}) => (pathname === "/codes" || pathname === "/tutorial/codes") ? "auto" : "calc(100% - 98px)"};
    background-color: #000;
`;
